import { render, staticRenderFns } from "./MedioPage.vue?vue&type=template&id=15ffde48&"
import script from "./MedioPage.js?vue&type=script&lang=js&"
export * from "./MedioPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports